// NetworkBanner.jsx
import React from "react";
import { Alert } from "reactstrap";

export default function NetworkBanner({ status, lastRtt }) {
  if (status === "good" || status === "unknown") return null;

  const color = status === "offline" ? "danger" : "warning";
  const msg =
    status === "offline"
      ? "Você está offline. Algumas ações podem não funcionar até a conexão voltar."
      : `Sua conexão parece lenta${lastRtt ? ` (~${Math.round(lastRtt)} ms)` : ""}. Operações podem demorar.`;

  return (
    <Alert
      color={color}
      className="mb-0 rounded-0 text-center fw-bold"
      style={{ position: "sticky", top: 0, zIndex: 1000 }}
    >
      {msg}
    </Alert>
  );
}
